export const POST_OTP_LOGIN = 'post-otp-login';
export const POST_INIT_OTP = 'post-init-otp';
export const POST_RETRY = 'post-retry';
export const GET_INVOICES = 'get-invoices';
export const GET_SEGMENTS = 'get-segments';
export const GET_VOUCHERS = 'get-vouchers';
export const POST_VALIDATE_SELECTION = 'post-validate-selection';
export const POST_VALIDATE_SELECTIONS = 'post-validate-selections';
export const POST_CREATE_TRANSACTIONS = 'post-create-transactions';
export const POST_CONFIRM = 'post-confirm';
export const POST_LOGIN_OPTIONS = 'post-login-options';
export const POST_LOGIN_COMPLETE = 'post-login-complete';
export const POST_REQUEST_CALL = 'post-request-call';
export const POST_CANCEL_CALL = 'post-cancel-call';
export const GET_FINAL_INVOICE = 'get-final-invoice';
export const GET_BANK_RECEIPT = 'get-bank-receipt';
export const GET_ADVERTISEMENT = 'get-advertisement';
export const POST_CHECK_WALLET_INQUIRY = 'post-check-wallet-inquiry';